import { render, staticRenderFns } from "./BidAskBroker.vue?vue&type=template&id=7d95f38c&scoped=true"
import script from "./BidAskBroker.vue?vue&type=script&lang=js"
export * from "./BidAskBroker.vue?vue&type=script&lang=js"
import style0 from "./BidAskBroker.vue?vue&type=style&index=0&id=7d95f38c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d95f38c",
  null
  
)

export default component.exports